import clsx from "clsx";
import {
  ChangeEvent,
  FormEvent,
  InputHTMLAttributes,
  useContext,
  useState,
} from "react";
import CheckoutContext from "../../../../checkout-context";

type SelectFormFieldProps = {
  label?: string;
  invalidMessage?: string;
  options: {
    name: string;
    value: string;
  }[];
} & InputHTMLAttributes<HTMLSelectElement>;

export function SelectFormField({
  label,
  name,
  id = name,
  defaultValue = "",
  placeholder,
  onChange,
  invalidMessage,
  options,
  ...props
}: SelectFormFieldProps) {
  const [isInvalid, setIsInvalid] = useState(false);
  const { textsMapping } = useContext(CheckoutContext);

  function handleChange(e: ChangeEvent<HTMLSelectElement>) {
    if (isInvalid) {
      setIsInvalid(!e.target.willValidate);
    }

    onChange?.(e);
  }

  function handleOnInvalid(e: FormEvent<HTMLSelectElement>) {
    e.preventDefault(); // Prevent native validation messages
    setIsInvalid(true);
  }

  return (
    <div className={clsx("form-field", isInvalid && "is-invalid")}>
      {label && <label htmlFor={id}>{label}</label>}
      <select
        onChange={(e) => handleChange(e)}
        onInvalid={handleOnInvalid}
        defaultValue={defaultValue}
        id={id}
        name={name}
        {...props}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option value={option.name} key={option.value}>
            {option.name}
          </option>
        ))}
      </select>
      {isInvalid && (
        <span className="field-validation-error">
          {invalidMessage || textsMapping.inputErrorMessageDefault}
        </span>
      )}
    </div>
  );
}
